import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { PlatformTemplate } from 'templates';
import {
  AppCategories,
  AppProducts,
  AppRequests,
  AppCategoryProductOptions,
  AppTables,
  AppSettings,
  AppUsers,
  Dashboard,
} from 'pages';

export default function Routes() {
  return (
    <PlatformTemplate>
      <Switch>
        <Route exact path="/app">
          <Dashboard />
        </Route>
        <Route exact path="/app/categories">
          <AppCategories />
        </Route>
        <Route exact path="/app/products">
          <AppProducts />
        </Route>
        <Route exact path="/app/requests">
          <AppRequests />
        </Route>
        <Route exact path="/app/category-product-options">
          <AppCategoryProductOptions />
        </Route>
        <Route exact path="/app/tables">
          <AppTables />
        </Route>
        <Route exact path="/app/settings">
          <AppSettings />
        </Route>
        <Route exact path="/app/users">
          <AppUsers />
        </Route>
      </Switch>
    </PlatformTemplate>
  );
}
